/**
 * Single source of truth for the backend /api base URL.
 * Supports REACT_APP_BACKEND_URL with or without a trailing /api segment.
 */
export function getApiBaseUrl() {
  const raw = (process.env.REACT_APP_BACKEND_URL || '').trim();
  if (!raw) return '/api';
  const base = raw.replace(/\/+$/, '');
  return base.endsWith('/api') ? base : `${base}/api`;
}
